import React, { useState } from 'react';
import { SovosBox, SovosCheckboxGroup, SovosIconButton, SovosTypography } from 'mosaic-react';
import { ArrowRightOutlined } from 'mosaic-react-icons';

const RelatedEntitiesTree = ({ entitiesByCombination, setSelectedItems }) => {

    const [expanded, setExpanded] = useState([]);

    const handleCheckboxChange = (related_entities, combination) => {
        setSelectedItems((prev) => {
            return {
                ...prev,
                [combination]: related_entities
            }
        });
    };

    const handleExpand = (index) => {
        if (expanded.includes(index)) {
            setExpanded(expanded.filter(item => item !== index));
        } else {
            setExpanded([...new Set([...expanded, index])]);
        }
    };


    return <>
        {(entitiesByCombination || []).map(({ combination, entities, related_entities }, index) => (
            <SovosBox key={index}>
                <SovosBox sx={{ display: 'flex', alignItems: 'center' }}>
                    <SovosIconButton sx={(expanded || []).includes(index) ? { transform: 'rotate(90deg)' } : {}} size="small" onClick={() => handleExpand(index)}>
                        <ArrowRightOutlined />
                    </SovosIconButton>
                    <SovosTypography>
                        {combination}
                    </SovosTypography>
                </SovosBox>
                <SovosBox sx={{ display: (expanded || []).includes(index) ? 'block' : 'none', marginLeft: '30px' }}>
                    <SovosCheckboxGroup options={(entities || []).map((entity) => ({
                        label: (entity || "").replace("CDM_", " "),
                        value: entity,
                        checked: related_entities.includes(entity)
                    }))}
                        onChange={(event) => handleCheckboxChange(event, combination)}>
                    </SovosCheckboxGroup>
                </SovosBox>
            </SovosBox>
        ))}
    </>;
};

export default RelatedEntitiesTree;